module.exports = __webpack_public_path__ + "static/media/euro.165e83da.svg";